import { useContext } from 'react';
import { NotificationManagerContext } from '../context/NotificationManagerContext';
import { NotificationManager } from '../notification/classes/NotificationManager/NotificationManager';
export function useNotificationManager() {
  return useContext(NotificationManagerContext).notificationManager;
}